import { FocusSelectionParams } from '../../coaching-base/config';
import {
    CommitmentFocusSummaryDto,
    CommitmentFocusSummarySetDto,
    FocusDto,
} from '../../coaching-base/general';
import { createAction } from '../../store.model';
import { BehaviourItem } from '../models/behaviour.coaching.model';
import { SubBehaviourItem } from '../models/subbehaviour.coaching.model';
import { TagItem } from '../models/tag.coaching.model';

export enum ActionType {
    COACHING_TAG_SET__INIT = 'COACHING_TAG_SET__INIT',
    COACHING_TAG_SET__INIT_RESULT = 'COACHING_TAG_SET__INIT_RESULT',
    COACHING_TAG_SET__TOGGLE_CATEGORY = 'COACHING_TAG_SET__TOGGLE_CATEGORY',
    COACHING_TAG_SET__SELECT_RECENT_TAG = 'COACHING_TAG_SET__SELECT_RECENT_TAG',
    COACHING_TAG_SET__FILTER_SELECTION_OPTIONS = 'COACHING_TAG_SET__FILTER_SELECTION_OPTIONS',
    COACHING_TAG_SET__FILTER_METRIC_SELECTION_OPTIONS = 'COACHING_TAG_SET__FILTER_METRIC_SELECTION_OPTIONS',
    COACHING_TAG_SET__SELECT_BEHAVIOUR = 'COACHING_TAG_SET__SELECT_BEHAVIOUR',
    COACHING_TAG_SET__SELECT_SUB_BEHAVIOUR = 'COACHING_TAG_SET__SELECT_SUB_BEHAVIOUR',
    COACHING_TAG_SET__TOGGLE_METRIC = 'COACHING_TAG_SET__TOGGLE_METRIC',
    COACHING_TAG_SET__SORT_GRID = 'COACHING_TAG_SET__SORT_GRID',
    COACHING_TAG_SET__CACHE = 'COACHING_TAG_SET__CACHE',
}

export interface TagSetInitAction {
    performerId?: number;
    selected?: FocusDto;
    pinnedMetrics?: number[];
    activeMetricId?: number;
    focusSelectionParams?: FocusSelectionParams;
}

export const tagSetInit = createAction<ActionType, TagSetInitAction>(
    ActionType.COACHING_TAG_SET__INIT,
);

export interface TagSetInitResultAction extends TagSetInitAction {
    focusSummarySet?: CommitmentFocusSummarySetDto;
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];

    /** active goal metrics of active commitments */
    activeCommitmentGoalMetrics?: number[];
}

export const tagSetInitResult = createAction<
    ActionType,
    TagSetInitResultAction
>(ActionType.COACHING_TAG_SET__INIT_RESULT);

/// //////////////////////

export interface TagSetToggleCategoryAction {
    category: 'active' | 'closed' | 'team' | string;
    isCollapsed: boolean;
}

export const tagSetToggleCategory = createAction<
    ActionType,
    TagSetToggleCategoryAction
>(ActionType.COACHING_TAG_SET__TOGGLE_CATEGORY);

/// //////////////////////

export interface TagSetSelectRecentTagAction {
    tagItem: TagItem;
}

export const tagSetSelectRecentTag = createAction<
    ActionType,
    TagSetSelectRecentTagAction
>(ActionType.COACHING_TAG_SET__SELECT_RECENT_TAG);

/// //////////////////////

export interface TagSetFilterSelectionOptionsAction {
    text: string;
}

export const tagSetFilterSelectionOptions = createAction<
    ActionType,
    TagSetFilterSelectionOptionsAction
>(ActionType.COACHING_TAG_SET__FILTER_SELECTION_OPTIONS);

/// //////////////////////

export interface TagSetFilterMetricSelectionOptionsAction {
    text: string;
}

export const tagSetFilterMetricSelectionOptions = createAction<
    ActionType,
    TagSetFilterMetricSelectionOptionsAction
>(ActionType.COACHING_TAG_SET__FILTER_METRIC_SELECTION_OPTIONS);

/// //////////////////////

export interface TagSetSelectBehaviourAction {
    behaviourId: number;
}

export const tagSetSelectBehaviour = createAction<
    ActionType,
    TagSetSelectBehaviourAction
>(ActionType.COACHING_TAG_SET__SELECT_BEHAVIOUR);

/// //////////////////////

export interface TagSetSelectSubBehaviourAction {
    subBehaviourId: number;
}

export const tagSetSelectSubBehaviour = createAction<
    ActionType,
    TagSetSelectSubBehaviourAction
>(ActionType.COACHING_TAG_SET__SELECT_SUB_BEHAVIOUR);

/// //////////////////////

export interface TagSetToggleMetricAction {
    metricId: number;
    checked: boolean;
}

export const tagSetToggleMetric = createAction<
    ActionType,
    TagSetToggleMetricAction
>(ActionType.COACHING_TAG_SET__TOGGLE_METRIC);

/// //////////////////////

export interface TagSetSortGridAction {
    columnId: string;
}

export const tagSetSortGrid = createAction<ActionType, TagSetSortGridAction>(
    ActionType.COACHING_TAG_SET__SORT_GRID,
);

/// //////////////////////

export interface TagSetCacheAction {
    tags: CommitmentFocusSummaryDto[];
    replace?: boolean;
}

// TODO maybe try to put this in a root state rather than into parent's state so that it's global
export const tagSetCache = createAction<ActionType, TagSetCacheAction>(
    ActionType.COACHING_TAG_SET__CACHE,
);
